/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function NewPassWordReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeNewPassWordAction } action: action de
 *     l'application
 * @return { Reducer }
 */
export const NewPassWordReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeNewPassWordAction) => {
      switch (action.type) {
        case actions.NewPassWordActionTypes.NEWPASSWORD_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.NewPassWordActionTypes.NEWPASSWORD_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.NewPassWordActionTypes.NEWPASSWORD_SUCCESS:

          return {
            data: action.payload.data, loading: false,
          }

          break;

        default:
          return state
          break;
      }
    }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/actions/newpassword/index.ts